"use client";
import { ErrorPromo } from "@/components/pages/error/ErrorPromo";
import { NextPageProps } from "@/types/shared";
import { Layout } from "@/components/layout/Layout";
import { icons } from "@/utils/favIcons";
import { useEffect } from "react";

const title = "500 | StudyBounty";

const description = "Internal server error!";

export default function Page(props: NextPageProps) {
  // NEXT JS BUG: next links not working correctly on custom error pages
  useEffect(() => {
    const links = Array.from(document.querySelectorAll("a"));

    const handleLinkClick = (event: MouseEvent) => {
      if (event.target && "href" in event.target) {
        location.href = String((event.target as HTMLAnchorElement).href);
      }
    };

    links.forEach((link) => {
      link.addEventListener("click", handleLinkClick);
    });

    return () => {
      links.forEach((link) => {
        link.removeEventListener("click", handleLinkClick);
      });
    };
  }, []);
  return (
    <Layout title={title} description={description}>
      <title>{title}</title>
      <meta property="description" content={description} />
      <ErrorPromo heading="500" subheading="Internal server error!" />
    </Layout>
  );
}
